'use client';

import { useCallback } from 'react';
import { useApi } from './use-api';
import { useBusy } from './use-busy';
import type {
    Translation,
    TranslationListParams,
    UpsertTranslationsDto,
} from '@/schemas/translation.schema';

export function useTranslationApi() {
    const { get, post } = useApi();
    const [, whileLoading] = useBusy();
    const [isSaving, whileSaving] = useBusy();

    const getList = useCallback(
        (params: TranslationListParams) =>
            whileLoading(() => {
                const apiParams: Record<string, string> = {
                    entity: params.entity,
                    ...(params.field ? { field: params.field } : {}),
                    ...(params.locale ? { locale: params.locale } : {}),
                    ...(params.entityIds && params.entityIds.length > 0
                        ? { entityIds: params.entityIds.join(',') }
                        : {}),
                };
                return get<Translation[]>('/translations', apiParams);
            }),
        [get, whileLoading]
    );

    const upsertMany = useCallback(
        (data: UpsertTranslationsDto) => whileSaving(() => post<Translation[]>('/translations/bulk', data)),
        [post, whileSaving]
    );

    return {
        getList,
        upsertMany,
        isSaving,
    };
}
